import * as z from 'zod/mini'
import { refineWithKey } from '../errors/validation-keys'
import { PasswordStrengthRegex } from '../business/validators/password-validator'
import { Gender } from '../types'
import { emailField, isoDateOrDateTime } from './common'
import { personFields } from './person'

/**
 * Field rules for a user account, shared by the registration, password and profile forms and the
 * HTTP bodies. Only a password being *set* is held to the strength rule; signing in accepts whatever
 * the account already has.
 */
export const userFields = {
  email: emailField,
  newPassword: z.string().check(
    z.maxLength(128),
    refineWithKey('validation.passwordStrength', (value: string) => PasswordStrengthRegex.test(value)),
  ),
  firstName: personFields.firstName,
  lastName: personFields.lastName,
  phone: personFields.phone,
  birthDate: isoDateOrDateTime,
  gender: z.enum(Gender),
  description: personFields.description,
  /** Staff's note on why an account was blocked (docs/user-blocking.md). Never shown to the blocked user. */
  blockedReason: z.string().check(z.trim(), z.maxLength(500)),
}
